/* eslint-disable import/no-unresolved */

/* eslint-enable import/no-unresolved */
import { createContext } from "react";
var useSelectContext = function useSelectContext() {
  var SelectContext = /*#__PURE__*/createContext(null);
  return SelectContext;
};
export default useSelectContext;